
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import Addvehicle from './pages/vehicles';
import SignIn from './pages/Login/Login';
import AllVehicles from './pages/vehicles';
import AddVehicle from './pages/Vehicles/AddVehicle';
import VehicleDetails from './pages/Vehicles/VehicleDetails';
import EditVehicle from './pages/Vehicles/EditVehicle';
import BookingRequests from './pages/Bookings/BookingRequests';
import NewAgreement from './pages/Agreement/NewAgreement';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from './Redux/Reducers/authSlice';
import { setLoader } from './Redux/Reducers/gernalSlice';
import Loader from './Components/Loader/Loader';
import GenerateAgreement from './pages/Agreement/GenerateAgreement';
import Agreements from './pages/Agreement/Agreements';
import Invoices from './pages/Invoices/Invoices';
import NewInvoice from './pages/Invoices/NewInvoice';
import TransactionDetails from './pages/Invoices/Transactions';
import Users from './pages/Users/Users';
import UserDetails from './pages/Users/UserDetails';
import TrashVehicles from './pages/Vehicles/TrashVehicles';
import CustomerInvoices from './pages/Invoices/CustomerInvoices';
import AddAgreementNote from './pages/Agreement/AddAgreementNote';
import AgreementNotes from './pages/Agreement/AgreementNotes';
import EditUser from './pages/Users/EditUser';
import UpcomingMots from './pages/Vehicles/UpcomingMots';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SupportPage from './pages/PrivacyPolicy/Support';
import PCOStatus from './pages/Vehicles/PCOStatus';
import VehicleRentalHistory from './pages/Vehicles/VehicleRentalHistory';
import CustomerRentalReport from './pages/Users/CustomerRentalReport';
import NewUser from './pages/Users/NewUser';


function App() {

  const dispatch = useDispatch();
  // dispatch(setUser({}));
  const user = useSelector((state) => state.authReducer.user);
  const loader = useSelector((state) => state.gernalReducer.loader);

  const checkSession = () => {

    const userLoginDateTime = new Date(user.loginDateTime);
    const dateAfter3Days = new Date(userLoginDateTime);
    dateAfter3Days.setDate(userLoginDateTime.getDate() + 3);
    if (userLoginDateTime > dateAfter3Days) {
      dispatch(setUser({}));
    }
  }

  useEffect(() => {
    checkSession();
    // dispatch(setUser({}));
    // dispatch(setLoader(false))
  }, [])
  if (user?._id) {
    return (
      <>
        {loader && <Loader />}
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/Addvehcile" element={<Addvehicle />} />
          <Route path="/vehicles" element={<AllVehicles />} />
          <Route path="/add-vehicle" element={<AddVehicle />} />
          <Route path="/trash-vehicles" element={<TrashVehicles />} />
          <Route path="/vehicle-details/:id" element={<VehicleDetails />} />
          <Route path="/edit-vehicle/:id" element={<EditVehicle />} />
          <Route path="/booking-requests" element={<BookingRequests />} />
          <Route path="/new-agreement/:cust_id?/:veh_id?/:booking_id?/" element={<NewAgreement />} />
          <Route path="/generate-agreement/:id?" element={<GenerateAgreement />} />
          <Route path="/agreements" element={<Agreements />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/new-invoices" element={<NewInvoice />} />
          <Route path="/transaction-details/:id" element={<TransactionDetails />} />
          <Route path="/users" element={<Users />} />
          <Route path="/user-details/:id" element={<UserDetails />} />
          <Route path="/cust-invoices/:id" element={<CustomerInvoices />} />
          <Route path="/add-agreement-note/:id" element={<AddAgreementNote />} />
          <Route path="/agreement-notes/:id" element={<AgreementNotes />} />
          <Route path="/edit-user/:id" element={<EditUser />} />
          <Route path="/upcoming-mots" element={<UpcomingMots />} />
          <Route path="/pco-status" element={<PCOStatus />} />

          <Route path="/privacy" exact element={<PrivacyPolicy />} />
          <Route path="/support" exact element={<SupportPage />} />

          <Route path="/rental-history/:id" element={<VehicleRentalHistory />} />
          <Route path="/customer-history/:id" element={<CustomerRentalReport />} />
          <Route path="/new-user" element={<NewUser />} />
        </Routes>

      </>
    );
  }
  else return (
    <>
      <Routes>
        <Route path="/" exact element={<SignIn />} />
        <Route path="/privacy" exact element={<PrivacyPolicy />} />
        <Route path="/support" exact element={<SupportPage />} />
      </Routes>
      {loader && <Loader />}

    </>
  )
}

export default App;
